export default __webpack_public_path__ + "static/media/Py.749e6ab4.jpeg";